// Vite does not support `require()` for asset URLs at runtime.
// Use ES imports — Vite returns the resolved asset URL string.
import logo from "../../assets/images/logo.png";
import spiral from "../../assets/images/spiral.png";

export default {
  logo,
  spiral,
};
